export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["min"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buy"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["for"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Advertisement Link"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maker ID"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Timeout"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Creation Date"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I will pay"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I will receive"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trade limit"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trades"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offer ID"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rate"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not within the limit"])}
}